import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  ExternalLink,
  H3,
  Link,
  Select,
  Panel,
  PanelBody,
  PanelHeader,
  PanelTitle,
  PanelSection,
  PanelSectionTitle,
  RadioGroup,
  RadioControl,
  Radio,
  RadioLabel,
  Icon,
} from '@studio/legacy-components';
import { selectRule, update as updateRule } from 'next/entities/rules';
import { selectGoalOptions } from 'next/lib/selectors-options';

import { GoalShape } from 'next/entities/goals';
import {
  GoalSelectWrapper,
  GoalInfoWrapper,
  IconWrapper,
  GoalInfo,
  NewGoal,
} from './styled';

export const DEFAULT_CONDITION = { version: { operator: '==', value: '' } };

export const Goal = ({ goalOptions, goal, onChange }) => {
  const [selectedMode, setSelectedMode] = useState(
    goal ? 'withGoal' : 'noGoal'
  );
  const selectedGoal = goalOptions.find(option => option.value === goal);

  const handleModeChange = mode => {
    setSelectedMode(mode);
    if (mode === 'noGoal') {
      onChange(null);
    }
  };
  const handleGoalChange = selected => {
    onChange(selected.value);
  };

  return (
    <Panel>
      <PanelHeader>
        <PanelTitle>
          <H3>Goal</H3>
        </PanelTitle>
      </PanelHeader>
      <PanelBody>
        <PanelSection>
          <PanelSectionTitle>
            Choose how to measure the success of this Flow
          </PanelSectionTitle>
          <RadioGroup
            name="version"
            value={selectedMode}
            onValueChange={handleModeChange}
          >
            <RadioControl>
              <Radio id="noGoal" value="noGoal" />
              <RadioLabel htmlFor="noGoal">
                No Goal — just track views and completions
              </RadioLabel>
            </RadioControl>

            <RadioControl>
              <Radio id="withGoal" value="withGoal" />
              <RadioLabel htmlFor="withGoal">
                Choose an existing Goal
              </RadioLabel>
            </RadioControl>
          </RadioGroup>
          {selectedMode === 'withGoal' && (
            <GoalSelectWrapper>
              <Select
                placeholder="Select a goal..."
                isSearchable={false}
                name="type"
                portal
                menuShouldBlockScroll
                value={selectedGoal}
                options={goalOptions}
                onChange={handleGoalChange}
              />
            </GoalSelectWrapper>
          )}
          <NewGoal>
            <Link to="/goals/new">Create a Goal</Link>
          </NewGoal>

          <GoalInfoWrapper>
            <IconWrapper>
              <Icon icon="lightbulb" />
            </IconWrapper>
            <GoalInfo>
              Measure how your Flows are influencing user behaviors in your
              product by{' '}
              <ExternalLink href="https://docs.appcues.com/article/280-goals">
                defining Goals
              </ExternalLink>
              . Using Goals can help you understand the ROI of your efforts.
            </GoalInfo>
          </GoalInfoWrapper>
        </PanelSection>
      </PanelBody>
    </Panel>
  );
};

Goal.propTypes = {
  goalOptions: PropTypes.arrayOf(GoalShape),
  goal: PropTypes.string,
  onChange: PropTypes.func,
};

const mapStateToProps = (state, { id }) => {
  const rule = selectRule(state, id);

  return {
    goalOptions: selectGoalOptions(state),
    goal: rule?.goals?.[0],
  };
};

const mapDispatchToProps = (dispatch, { id }) => ({
  onChange: goalId => dispatch(updateRule(id, { goals: [goalId] })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Goal);
